import { render, staticRenderFns } from "./HeadDetails.vue?vue&type=template&id=d9c0d0d0&scoped=true&"
import script from "./HeadDetails.vue?vue&type=script&lang=js&"
export * from "./HeadDetails.vue?vue&type=script&lang=js&"
import style0 from "./HeadDetails.vue?vue&type=style&index=0&id=d9c0d0d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c0d0d0",
  null
  
)

export default component.exports